// extracted by mini-css-extract-plugin
export var callCard = "_p8-0";
export var callMessageButton = "_p8-1";
export var helpIcon = "_p8-3";
export var helpIconContainer = "_p8-4";
export var verticalDivider = "_p8-2";